import React, { useState, useEffect } from 'react';
import { Card, Container, Form, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { database } from '../firebase';
import { ref, onValue, set } from 'firebase/database';
import { useVersionInfo } from '../hooks/useVersionInfo';

const Profile = () => {
  const { currentUser } = useAuth();
  const versionInfo = useVersionInfo();
  const [userName, setUserName] = useState('');
  const [tempUserName, setTempUserName] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const userNameRef = ref(database, `user_settings/${currentUser.uid}/UserName`);
    const unsubscribe = onValue(userNameRef, (snapshot) => {
      const data = snapshot.val();
      setUserName(data || '');
      setTempUserName(data || '');
    });

    return () => {
      unsubscribe();
    };
  }, [currentUser]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    if (!currentUser) return;

    const userNameRef = ref(database, `user_settings/${currentUser.uid}/UserName`);
    await set(userNameRef, tempUserName);
    setUserName(tempUserName);
    setIsEditing(false);
  };

  const handleCancelClick = () => {
    setTempUserName(userName);
    setIsEditing(false);
  };

  return (
    <Container className="mt-4">
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Profile Settings</Card.Title>
          <div className="mb-3">
            <strong>Email:</strong> {currentUser?.email}
          </div>
          <div className="mb-3">
            <strong>User Name:</strong>{' '}
            {isEditing ? (
              <div className="d-flex gap-2">
                <Form.Control
                  type="text"
                  value={tempUserName}
                  onChange={(e) => setTempUserName(e.target.value)}
                />
                <Button onClick={handleSaveClick}>Save</Button>
                <Button variant="secondary" onClick={handleCancelClick}>
                  Cancel
                </Button>
              </div>
            ) : (
              <div className="d-flex gap-2 align-items-center">
                {userName || 'Not set'}
                <Button variant="link" onClick={handleEditClick} className="p-0">
                  Edit
                </Button>
              </div>
            )}
          </div>
          <div className="mb-3">
            <strong>Last Sign In:</strong> {currentUser?.metadata.lastSignInTime}
          </div>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Version Information</Card.Title>
          <div className="mb-3">
            <strong>Version:</strong> {versionInfo.version}
          </div>
          <div className="mb-3">
            <strong>Release Date:</strong> {new Date(versionInfo.releaseDate).toLocaleDateString()}
          </div>
          <div className="mb-3">
            <strong>Author:</strong> {versionInfo.author}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Profile;
